import gql from "graphql-tag";

export const referralAgentsList = gql`
  query referralAgents($id: ID) {
    referralAgents(id: $id) {
      agents
    }
  }
`;